import * as React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';

interface Props {}

export const InfoMessage = (props: React.PropsWithChildren<Props>) => (
  <MessageBar
    messageBarType={MessageBarType.info}
    styles={{
      root: { background: 'rgba(113, 175, 229, 0.2)', color: '#00188f', padding: 10 },
      icon: { color: '#00188f' },
    }}
    isMultiline={true}
  >
    {props.children}
  </MessageBar>
);
